export default __webpack_public_path__ + "static/media/Turkey.63d75309.svg";